import axios from 'axios';
import {
  APPOINTMENT_REQUEST,
  APPOINTMENT_FAIL,
  APPOINTMENT_CREATE,
  APPOINTMENT_GET_ALL,
  APPOINTMENT_GET_ONE,
  APPOINTMENT_UPDATE,
  APPOINTMENT_DELETE
} from './types';

import { baseURL } from './types'; // baseURL = 'http://3.27.121.21:3331'

const API_URL = `${baseURL}/api/appointmentBookingInfo`;

// ✅ Create Appointment
export const createAppointment = (data) => async (dispatch) => {
    try {
      dispatch({ type: APPOINTMENT_REQUEST });
  
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
  
      const res = await axios.post(`${API_URL}/create`, data, config);
      dispatch({ type: APPOINTMENT_CREATE, payload: res.data });
  
      return { type: APPOINTMENT_CREATE, payload: res.data }; // ✅ Return value for component
    } catch (err) {
      dispatch({ type: APPOINTMENT_FAIL, payload: err.message });
      throw err; // Optional: allow component to catch error
    }
  };
  
// ✅ Get All Appointments
export const getAllAppointments = (hospitalID) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_REQUEST });

    const token = localStorage.getItem('token');
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const res = await axios.post(`${API_URL}/getall`, {hospitalID}, config);
    dispatch({ type: APPOINTMENT_GET_ALL, payload: res.data.data });
  } catch (err) {
    dispatch({ type: APPOINTMENT_FAIL, payload: err.message });
  }
};

// ✅ Get One Appointment (ID in body)
export const getAppointmentById = (id) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_REQUEST });

    const token = localStorage.getItem('token');
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const res = await axios.post(`${API_URL}/getOne`, { id }, config);
    dispatch({ type: APPOINTMENT_GET_ONE, payload: res.data });
  } catch (err) {
    dispatch({ type: APPOINTMENT_FAIL, payload: err.message });
  }
};

// ✅ Update Appointment
export const updateAppointment = (data) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_REQUEST });

    const token = localStorage.getItem('token');
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const res = await axios.patch(`${API_URL}/update`, data, config);
    dispatch({ type: APPOINTMENT_UPDATE, payload: res.data });
  } catch (err) {
    dispatch({ type: APPOINTMENT_FAIL, payload: err.message });
  }
};


// ✅ Delete Appointment (ID in body)
export const deleteAppointment = (id) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_REQUEST });

    const token = localStorage.getItem('token');
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      data: { id }, // DELETE body in Axios must go under "data"
    };

    const res = await axios.delete(`${API_URL}/delete`, config);
    dispatch({ type: APPOINTMENT_DELETE, payload: id });
  } catch (err) {
    dispatch({ type: APPOINTMENT_FAIL, payload: err.message });
  }
};
